
import { Network, Subnet } from '@/api/interfaces';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { toNetmask, ipAddressPre } from '@/helpers';

interface SubnetWithSort extends Subnet {
  paddedCIDR: string | number;
  mask: string;
}

@Component
export default class CampusUserNetworkSubnets extends Vue {
  @Prop() private network!: Network;
  private sortBy = 'paddedCIDR';
  private sortDesc = false;
  private headers: DataTableHeader[] = [
    {
      text: 'IP naslov podomrežja',
      align: 'start',
      sortable: true,
      sort: (a: string, b: string) => {
        return a < b ? -1 : a > b ? 1 : 0;
      },
      value: 'paddedCIDR',
    },
    { text: 'Prehod', value: 'gateway' },
    { text: 'Akcije', value: 'actions' },
  ];

  private openSubnetDetailsModal(subnet: Subnet) {
    this.$modals.open('app-subnet-detail-modal', {
      component: {
        props: {
          subnet: subnet,
        },
      },
      dialog: {
        props: {
          'max-width': '600px',
          'persistent': false,
        },
      },
    });
  }

  private get subnets(): SubnetWithSort[] {
    if (this.network) {
      return this.network.subnets.map((subnet: Subnet) =>
        Object.assign(subnet, {
          paddedCIDR: ipAddressPre(subnet.cidr),
          mask: toNetmask(subnet.cidr, subnet.version ? subnet.version : 6),
        }),
      );
    } else {
      return [];
    }
  }
}
